import React, { useEffect, useState } from 'react';
import WidgetCarouselProps from '../widget-carousel.props';
import WidgetCarouselDesktopBasic from './components/widget-carousel-desktop-basic';

import './widget-carousel.desktop.scss';

const WidgetCarouselDesktop: React.FC<WidgetCarouselProps> = ({ config, data }) => {
    const [WidgetCarouselComponent, setWidgetCarousel] = useState<React.ComponentType<any>>(() => WidgetCarouselDesktopBasic);

    // autoPlay = false, imgHeight, itemsOnScreen, lazyLoad,
    useEffect(() => {
        import('react-multi-carousel').then(mod => {
            setWidgetCarousel(() => mod.default);
        });
    }, []);

    const responsive = {
        desktop: {
            breakpoint: { max: 5000, min: 1024 },
            items: config.itemsOnScreen ?? 5
        }
    };

    return (
        <div className="w-carousel-d">
            <WidgetCarouselComponent
                responsive={responsive}
                swipeable={false}
                draggable={false}
                slidesToSlide={config.itemsOnScreen ?? 5}
                renderButtonGroupOutside={true}
                customButtonGroup={false}
                arrows={true}
                autoPlay={config.autoPlay}
                className="w-carousel-d__list"
                itemClass={`w-carousel-d__list__item w-${config.itemsOnScreen ?? 5} h-${config.itemsOnScreen ?? 5}`}
            >
                {
                    data.map(item => (
                        <a
                            rel={item.target === '_blank' ? 'nofollow noopener' : ''}
                            href={item.url}
                            target={item.target}
                            className="w-carousel-d__list__item__content"
                            key={item.url}
                        >
                            <div className="w-carousel-d__list__item__content__image">
                                <img
                                    src={item.img}
                                    alt={item.title}
                                    loading={config.lazyLoad ? 'lazy' : 'eager'}
                                />
                            </div>
                        </a>
                    ))
                }
            </WidgetCarouselComponent>
        </div>
    );
};

export default WidgetCarouselDesktop;
